import { FilterComponent } from "./tag/filters";
import InfinityScroll from "../components/infinityScroll";
import setTopBar from "../components/topBar.js";
import setFullbanner from "./home/1_fullbanner.js";
import ProductSpanSelector from "./tag/productSpanSelector";

const Tag = {
  init: function () {
    setTopBar();
    setFullbanner();
    ProductSpanSelector.init();
    FilterComponent.init();
    InfinityScroll.init();
  },
};

window.addEventListener("DOMContentLoaded", () => {
  Tag.init();
});
